import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

/**
 * Viral affiliate badge displayed on PUBLIC pages (briefs submitted by end-clients).
 * Clicking it lands the visitor on the homepage with a referral query param
 * so we can track viral acquisition later if needed.
 *
 * Props:
 *  - variant: "floating" (fixed bottom-right) | "inline" (block at the end of content)
 */
export default function PoweredBy({ variant = "inline" }) {
  const base = (
    <Link
      to="/?ref=brief"
      data-testid="powered-by-xookpub"
      className="group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full
                 border border-gold/30 bg-obsidian/80 backdrop-blur-md
                 hover:border-gold hover:bg-gold/10 transition-all duration-300"
      title="Créez votre publicité avec XookPub"
    >
      <Sparkles className="w-3.5 h-3.5 text-gold group-hover:rotate-12 transition-transform" />
      <span className="label-mono text-[10px] text-white/50">PROPULSÉ PAR</span>
      <span className="font-heading text-sm tracking-tight">
        Xook<span className="gold-text font-bold">Pub</span>
      </span>
    </Link>
  );

  if (variant === "floating") {
    return (
      <div className="fixed bottom-5 right-5 z-40 hidden sm:block" data-testid="powered-by-floating">
        {base}
      </div>
    );
  }

  return (
    <div className="mt-12 flex flex-col items-center gap-3 pt-8 border-t border-white/5">
      {base}
      <p className="text-xs text-white/40 text-center max-w-xs">
        Vous aussi, créez vos publicités flyers, vidéos et voix off avec l'IA.
      </p>
    </div>
  );
}
